import AppCardTabListContainer from '@nxsys/components/AppCardTabListContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useMemo, useState } from 'react';
import LeaverFPS from './LeaverFPS';
import NormalFPS from './NormalFPS';

type Props = {
  isOpen: boolean;
  toggle: () => void;
};

enum FPSModalTabEnum {
  NORMAL = 'NORMAL',
  LEAVER = 'LEAVER',
}

const FPSModal: React.FC<Props> = ({ isOpen, toggle }) => {
  const tabs = useMemo(
    () => [
      {
        tab: 'Normal',
        key: FPSModalTabEnum.NORMAL,
      },
      {
        tab: 'Leaver',
        key: FPSModalTabEnum.LEAVER,
      },
    ],
    [],
  );

  const [activeTab, setActiveTab] = useState<FPSModalTabEnum>(
    FPSModalTabEnum.NORMAL,
  );

  const handleTabChange = (key: FPSModalTabEnum) => {
    setActiveTab(key);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case FPSModalTabEnum.NORMAL:
        return <NormalFPS />;
      case FPSModalTabEnum.LEAVER:
        return <LeaverFPS />;
      default:
        return <></>;
    }
  };

  return (
    <AppModalContainer
      title="FPS"
      isOpen={isOpen}
      toggle={toggle}
      hiddenFooter
      className="max-sm:w-[100vw"
      width={1200}
      minHeight="0"
      noPaddingBody
    >
      <AppCardTabListContainer
        tabList={tabs}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
        className="!border-none"
      >
        {renderTabContent()}
      </AppCardTabListContainer>
    </AppModalContainer>
  );
};

export default FPSModal;
